import { schema } from "normalizr";
export const openBuyExtensions = new schema.Entity(
    "openBuyExtensions",
    {},
    { idAttribute: "publisherId" }
);
export const openBuyExtensionList = new schema.Array(openBuyExtensions);
